export default __webpack_public_path__ + "59e2ac7a2d2cb61906e45958957b585e.jpg";